module.exports = __webpack_public_path__ + "img/Jump Casting113.2582357e.jpg";